import { type EmojiId, type TagResponse } from '../emoji';
import { type ResourceId } from '../general';

export interface YatPageResponse {
    id: ResourceId;
    eid: EmojiId;
    featured_id: ResourceId;
    bio: string;
    heading: string;
    liquid_id: ResourceId;
    user_id: ResourceId;
    draft_heading: string;
    draft_bio: string;
}

interface YatPageVersion1Response {
    version: YatPageVersion.V1;
    v1: TagResponse;
    v2: null;
}

export interface YatPageVersion2Response {
    version: YatPageVersion.V2;
    notFound: boolean;
    v1: null;
    v2: YatPageResponse;
}

export type YatPageVersionResponse = YatPageVersion1Response | YatPageVersion2Response;

type CreateYatPageName = {
    canonical: string;
    preferred: string;
};

export interface CreateYatPageParams {
    eid: string | CreateYatPageName;
    bio?: string;
    heading?: string;
    draft_heading?: string;
    draft_bio?: string;
}

export enum YatPageVersion {
    V1 = 'V1',
    V2 = 'V2',
    NOT_FOUND = 'NOT_FOUND',
}

export type YatPageProfileResponse = YatPageResponse & {
    created_at: ReturnType<Date['toISOString']>;
    updated_at: ReturnType<Date['toISOString']>;
    social_links_id: ResourceId;
    draft_bio: string | null;
    draft_heading: string | null;
};
